import { getStatus } from '../data/projectStatus';

export const formatPhoneHref = (phone) =>
  `tel:${String(phone).replace(/[^+\d]/g, '')}`;

export const getStatusLabel = (status) => getStatus(status).label;

export const getStatusTone = (status) => getStatus(status).tone;

export const capitalize = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1);
